import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BFFHttpError } from '../model/BFFHttpError';
import type { CustomersValidateTrackOrderRequest } from './model';

export const useCustomerValidateTrackOrder = (): UseMutationResult<
    boolean,
    unknown,
    CustomersValidateTrackOrderRequest
> =>
    useBffPostMutation('/customers/validate-track-order', [], [], {
        onSuccess: () => true,
        onError: (error) => {
            if (error instanceof BFFHttpError && error.status === 404) {
                return false;
            }
            throw error;
        },
    });
